import React, { useEffect } from 'react'
import OrderCard from './OrderCard';
import { useDispatch, useSelector } from 'react-redux';
import { store } from '../State/store';
import { useNavigate } from 'react-router-dom';
import { getUSerOrders } from '../State/Order/Action';

const Orders = () => {
    const {auth,cart,order}=useSelector((store=>store));
    const navigate=useNavigate();
    const jwt=localStorage.getItem("jwt");
    const dispatch=useDispatch();

    useEffect(()=>{
        dispatch(getUSerOrders(jwt))
    },[auth.jwt])
  return (
    <div className='flex items-center flex-col'>
        <h1 className='text-xl text-cener py-7 font-semibold'>
            My Orders
        </h1>
        <div className='space-y-5 w-full lg:w-1/2'>
        {
            order.orders.map((order)=>order.items((item)=><OrderCard  order={order} item={item}/>))
        }
        </div>
    </div>
)

}

export default Orders;